import BasePerimeter from '@/perimeters/BasePerimeter';

export default new BasePerimeter({
  purpose: 'sanmer',

  can: {
    all() {
      return this.hasPermission('sanmer-read');
    },

    create() {
      return this.hasPermission('sanmer-write');
    },

    read() {
      return this.hasPermission('sanmer-read');
    },

    update(sanmer) {
      return this.isCreator(sanmer) || this.hasPermission('sanmer-update');
    },

    destroy() {
      return this.hasPermission('sanmer-delete');
    }
  },

  isCreator(sanmer) {
    if (!sanmer) return false;

    return this.child.id === sanmer.child_id;
  }
});
